import { BaseModel } from "models/BaseModel";
import { City } from "./City";
import { AddressFields, AddressProps, CityProps } from "./types";

export class Address extends BaseModel {
	[AddressFields.ID]: string;
	[AddressFields.POSTAL_CODE]: string;
	[AddressFields.STREET]: string;
	[AddressFields.NUMBER]: number;
	[AddressFields.COMPLEMENT]: string;
	[AddressFields.NEIGHBOURHOOD]: string;
	[AddressFields.CITY]: CityProps;

	constructor(data: AddressProps) {
		super(data);

		this[AddressFields.ID] = data[AddressFields.ID];
		this[AddressFields.POSTAL_CODE] = data[AddressFields.POSTAL_CODE];
		this[AddressFields.STREET] = data[AddressFields.STREET];
		this[AddressFields.NUMBER] = data[AddressFields.NUMBER];
		this[AddressFields.COMPLEMENT] = data[AddressFields.COMPLEMENT];
		this[AddressFields.NEIGHBOURHOOD] = data[AddressFields.NEIGHBOURHOOD];
		this[AddressFields.CITY] = data.city && new City(data.city);
	}
}
